import OpenAI from 'openai'
import type { CardLevel } from '../types/card'

const client = new OpenAI({
  apiKey: import.meta.env.VITE_DEEPSEEK_API_KEY,
  baseURL: 'https://api.deepseek.com',
  dangerouslyAllowBrowser: true,
})

export interface AIWord {
  front: string
  kanji: string
  meaning: string
}

const LEVEL_LABELS: Record<CardLevel, string> = {
  Gojuon: '五十音图（假名）',
  N5: 'N5',
  N4: 'N4',
  N3: 'N3',
  N2: 'N2',
  N1: 'N1',
}

export async function generateVocabularyFromAI(
  level: CardLevel,
  count: number = 15
): Promise<AIWord[]> {
  const jlptLabel = LEVEL_LABELS[level] || level

  const prompt = `你是一个专业的日语 JLPT 教师。请为我严格按照 ${jlptLabel} 级别的大纲，随机生成 ${count} 个极其常用的核心日语单词。绝对不能和我以前学过的重复。必须严格只输出以下 JSON 数组格式，不要带任何 Markdown 标记或前言后语：[{"front": "日文汉字或假名", "kanji": "平假名读音", "meaning": "中文释义"}]`

  const res = await client.chat.completions.create({
    model: 'deepseek-chat',
    messages: [{ role: 'user', content: prompt }],
    max_tokens: 1000,
    temperature: 1.0,
  })

  const raw = res.choices[0]?.message?.content?.trim() ?? ''
  const jsonStr = raw.replace(/```json\s*/gi, '').replace(/```\s*/g, '').trim()

  try {
    const parsed = JSON.parse(jsonStr)
    if (!Array.isArray(parsed)) return []
    return parsed.map((item: any) => ({
      front: String(item.front ?? ''),
      kanji: String(item.kanji ?? ''),
      meaning: String(item.meaning ?? ''),
    }))
  } catch {
    console.error('AI 造词解析失败，原始响应:', raw)
    return []
  }
}
